export type SeatMode = 'odd' | 'even';

export const seatMatchesMode = (seat: number, mode: SeatMode): boolean =>
  Number.isInteger(seat) && (mode === 'odd' ? seat % 2 !== 0 : seat % 2 === 0);

export type SeatModePlan = { keep: number[]; remove: number[] };

/** What choosing odd or even does to a group: the seats that stay and the ones removed. null (clear) changes no seats. */
export function planSeatMode(seats: number[], mode: SeatMode | null): SeatModePlan {
  const sorted = Array.from(new Set(seats.filter((s) => Number.isFinite(s)))).sort((a, b) => a - b);
  if (!mode) return { keep: sorted, remove: [] };
  return {
    keep: sorted.filter((s) => seatMatchesMode(s, mode)),
    remove: sorted.filter((s) => !seatMatchesMode(s, mode)),
  };
}

export const seatModeLabel = (mode: SeatMode | null | undefined): string =>
  mode === 'odd' ? 'Odd' : mode === 'even' ? 'Even' : '';
